/**
 * 공지 알림톡 발송 플래그 유틸.
 * 서버는 isAlimtalkSend 생략 시 true 로 간주하므로 프론트는 항상 boolean 을 보낸다.
 */
import { SCHEDULE_NOTICE_CATEGORY } from '@/pages/board/boardUtils';
import type { BadgeProps } from '@/shared/components/ui/badge';

/** 일정 안내 + 게시 + 체크일 때만 실제 발송 대상 */
export const willSendNoticeAlimtalk = (params: {
  category: string;
  isPublished: boolean;
  isAlimtalkSend: boolean;
}): boolean =>
  params.category === SCHEDULE_NOTICE_CATEGORY &&
  params.isPublished &&
  params.isAlimtalkSend;

/**
 * 저장 요청용 isAlimtalkSend.
 * 일정 안내가 아니거나 미게시면 false. 일정·게시일 때만 체크 상태를 그대로 보낸다.
 */
export const resolveNoticeAlimtalkSendPayload = (params: {
  category: string;
  isPublished: boolean;
  isAlimtalkSendChecked: boolean;
}): boolean => {
  if (params.category !== SCHEDULE_NOTICE_CATEGORY) return false;
  if (!params.isPublished) return false;
  return params.isAlimtalkSendChecked;
};

/** 상세 보기용 — 마지막 저장에서 알림톡 발송을 요청했는지 */
export const getNoticeAlimtalkSendLabel = (isAlimtalkSend: boolean): string =>
  isAlimtalkSend ? '알림톡 발송' : '알림톡 미발송';

export const getNoticeAlimtalkSendBadgeVariant = (
  isAlimtalkSend: boolean,
): NonNullable<BadgeProps['variant']> =>
  isAlimtalkSend ? 'info' : 'secondary';
